<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="surgery-list"
            :url="url"
            :columns="columnList"
            :editColums="editColumnList"
            :buttons="buttons"
            :editButtons="editButtons"
            dialogWidth="80%"
            :tableHeight="screenHeight - 175"
            :addButton="{ label: '创建手术', permission: 'default' }"
            :updateButton="{ enabled: false }"
            :columnConfig="columnConfig"
            :selection="true"
            @selectionChange="checkedRow"
            @loadingOverruleView="loadingOverruleView"
            @LoadingUpdateViewThis="LoadingUpdateViewThis"
            @cancelSurgeryApplyYes="cancelSurgeryApplyYes"
            @cancelSurgeryApplyNo="cancelSurgeryApplyNo"
        >
            <slot slot="filter">
                <el-col :span="8">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="multiselect" v-model="surgery_status" :options="sys_enums && sys_enums.SurgeryStatus" :clearable="true" placeholder="手术状态"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="dic_room_id" :options="operationRoom" :clearable="true" placeholder="手术间"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="selectsurgeryType" :options="surgeryTypes" placeholder="类型" @input="changed"></item-input>
                </el-col>
                <el-col :span="3">
                    <item-input type="select" v-model="custom_status_model" :options="customStatus" :clearable="true" placeholder="状态"></item-input>
                </el-col>
            </slot>
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="ReadCard()" v-show="showSwipeCard">读卡<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="btnprintCard()" v-show="showSwipeCard">打印条码<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="ReloadListData()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="btnprint()">打印<i class="el-icon--right"></i></el-button>
            </template>
            <span slot="push_status" slot-scope="{ row }">
                <i v-if="row.push_status == 1" class="el-icon-circle-check fg-primary"> </i>
                <i v-else-if="row.push_status == 2" class="el-icon-circle-check-outline fg-warning" :title="row.push_status_msg"></i>
                <i v-else-if="row.push_status == 3" class="el-icon-circle-close fg-danger" :title="row.push_status_msg"></i>
                <i v-else> </i>
            </span>
            <template slot="patient_info" slot-scope="{ row }">
                <el-row>
                    <el-col :span="1" class="height-p100">
                        <div class="surgery-status-tag" :title="row.surgery_status"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                            :style="{ height: isShowDiseases && isShowDiseases == '1' ? `110px` : `80px` }">
                            &nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v align-left" :title="titleLabel(row)">
                        <div class="ellipsis">
                            <b>
                                <span class="circle fg-red borderd" v-show="row.is_reoperation">再</span>
                                <!-- {{ `${row.patient_name}(${row.sex || '--'} / ${row.age || '--'} / ${row.bed_no || '--'}床 / ${row.visit_no})` }} -->
                                {{ `${row.patient_name}(${row.sex || '--'}` }}
                                <i style="color: red !important">/</i>{{ ` ${row.age || '--'} ` }} <i
                                    style="color: red !important">/</i>{{ ` ${row.bed_no || '--'}床 ` }}
                                <i style="color: red !important">/</i>{{ ` ${row.visit_no || '--'}` }}<i
                                    style="color: red !important">/</i>{{ ` ${row.outpatient_no || '--'})` }}
                            </b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                        <div v-show="isShowDiseases && isShowDiseases == '1'">
                            <b class="ellipsis">{{ row.diseases }}</b>
                        </div>
                        <div v-if="!proc_GetTipItemsSchedule || proc_GetTipItemsSchedule == '0'">
                            <el-tag :style="{
                                                color: row.enum_surgery_type > 1 ? '#2A918A' : 'red',
                                                borderColor: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }" size="mini">{{ row.surgery_type }}</el-tag>
                            <!-- <el-tag style="color: #f56c6c; border-color: #f56c6c; background-color: white" size="mini" v-if="row.enum_surgery_type">{{ row.surgery_type }}</el-tag> -->
                            <el-tag :style="{
                                                color: row.enum_surgery_status >= 40 ? '#DFE2E7' : '#52b8d2',
                                                borderColor: row.enum_surgery_status == 40 ? '#DFE2E7' : '#52b8d2',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }" size="mini">{{ row.enum_surgery_status > 10 ? '已排' : '待排' }}</el-tag>
                            <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white; font-weight: bold"
                                size="mini">{{
                                row.enum_visit_type == 1 ? '住院' : row.enum_visit_type == 2 ? '门诊' : '体检'
                                }}</el-tag>
                            <el-tag
                                :style="{ color: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', borderColor: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', backgroundColor: 'white', fontWeight: 'bold' }"
                                size="mini">日间</el-tag>
                            <el-tag
                                :style="{ color: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', borderColor: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', backgroundColor: 'white', fontWeight: 'bold' }"
                                size="mini">内镜</el-tag>
                            <el-tag :style="{
                                                color: row.infectious && row.infectious != '无' && row.infectious != 'NONE' && row.infectious != '未查' && row.infectious != 'NoCheck' ? 'red' : '#DFE2E7',
                                                borderColor: row.infectious ? '#f2b04b' : '#DFE2E7',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }" size="mini">传染病</el-tag>
                            <el-tag :style="{
                                                color: row.is_local_anes && row.is_local_anes == true ? '#5AA7B0' : '#DFE2E7',
                                                borderColor: row.is_local_anes ? '#5AA7B0' : '#DFE2E7',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }" size="mini">局麻
                            </el-tag>
                        </div>
                        <div v-else>
                            <span v-for="item in row.patientInfoTipItemsList" :index="item.label" :key="item.label">
                                <el-tag :style="item.style" :title="item.title" size="mini">{{ item.label }}</el-tag>&nbsp;
                            </span>
                        </div>
                    </el-col>
                </el-row>
            </template>
        </crud-facecade>
        <form-dialog :title="overrule.title" :data="overrule.data" :visible.sync="overrule.dialogFormVisible" :columns="overrule.columns" @confirm="saveOverrule"></form-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `ApplySurgery`,
    props: {},
    data() {
        let validateLength = (rule, value, callback) => {
            if (this.rejectReasons && this.rejectReasons.length > 0) {
                if (value && value.trim().length < 2) {
                    callback(new Error(`驳回理由不能少于2个字符`))
                } else {
                    callback()
                }
            } else {
                if (value && value.trim().length < 4) {
                    callback(new Error(`驳回理由不能少于4个字符`))
                } else {
                    callback()
                }
            }
        }
        return {
            title: `手术申请`,
            rejectReasons: [],
            rejectClasss: [],
            checkedRows: [],
            surgeryinfopush: this.$root.SurgeryInfoPush,
            url: {
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    return new Promise(resolve => {
                        this.ReloadData().then(data => {
                            resolve(data)
                        })
                    })
                },
                post: data => {
                    return new Promise((resolve, reject) => {
                        this.validateData(data)
                        if (data.isExtraBtnClick && !data.dic_operating_room_id) {
                            this.$message.error(`请选择手术间！`)
                            throw new Error(`EndIterative`)
                        }
                        let obj = {
                            sequence: data.sequence,
                            apply_time: data.apply_time,
                            plan_time: data.plan_time,
                            cost_time: data.cost_time,
                            infectious: data.infectious && data.infectious.join(`,`),
                            is_fasting: data.is_fasting,
                            is_day_surgery: data.is_day_surgery,
                            is_endoscopy: data.is_endoscopy,
                            remark: data.remark,
                            enum_asa: data.enum_asa,
                            enum_surgery_scale: data.enum_surgery_scale,
                            enum_surgery_type: data.enum_surgery_type,
                            dic_section_id: data.sectionobj && data.sectionobj.value || `-1`,
                            dic_inpatient_section_id: data.inpatientobj && data.inpatientobj.value || `-1`,
                            dic_operating_room_id: data.dic_operating_room_id,
                            dic_operating_room: data.dic_operating_room,
                            dic_operating_ward_id: data.dic_operating_ward_id,
                            enum_isolation_status: data.enum_isolation_status,
                            enum_cut_level: data.enum_cut_level,
                            iconValue: `el-icon-star-on`,
                            custom_status: data.custom_status,
                            visit_info: {
                                age: data.age,
                                nation: data.nation,
                                height: data.height,
                                weight: data.weight,
                                bed_no: data.bed_no,
                                visit_no: data.visit_no,
                                outpatient_no: data.outpatient_no,
                                visit_time: data.visit_time,
                                phone: data.phone,
                                address: data.address,
                                enum_visit_type: data.enum_visit_type,
                                enum_pay_type: data.enum_pay_type,
                                name: data.name,
                                birthday: data.birthday,
                                card_type: data.card_type,
                                card_no: data.card_no,
                                insurance_no: data.insurance_no,
                                enum_blood_type: data.enum_blood_type,
                                enum_rh_blood_type: data.enum_rh_blood_type,
                                enum_sex: data.enum_sex,
                                his_id: data.his_id
                            },
                            plan_anaes_methods: data.plan_anaes_methods,
                            plan_diseases: data.plan_diseases.map(d => d.value),
                            plan_surgeries: data.plan_surgeries.map(d => d.value),
                            plan_surgeon: data.plan_surgeon && data.plan_surgeon.value,
                            plan_surgeon_assistants: data.plan_surgeon_assistants && data.plan_surgeon_assistants.map(d => d.value),
                            plan_anes_doctor: data.plan_anes_doctor && data.plan_anes_doctor.value,
                            plan_anes_assistants: data.plan_anes_assistants && data.plan_anes_assistants.map(d => d.value),
                            plan_circuit_nurse: data.plan_circuit_nurse && data.plan_circuit_nurse.map(d => d.value),
                            plan_equipment_nurse: data.plan_equipment_nurse && data.plan_equipment_nurse.map(d => d.value),
                            is_extra: data.isExtraBtnClick,
                            is_local_anes: data.is_local_anes
                        }
                        // 新增的时候把动态列字段放到obj.extra_datas对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(this.extendColumnList, obj, data)
                        let req = this.myaxios.post(`/api/Preoperative/Apply/Post`, obj)
                        let that = this
                        req.then(res => {
                            that.$refs[`surgery-list`].ReloadListData()
                            resolve(res)
                        }).catch(e => reject(e))
                    })
                },
                getOne: row => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${row.id}`)
                        req.then(data => {
                            let obj = {
                                id: data.id,
                                is_archived: data.is_archived, // 手术对应的麻醉单是否已归档
                                sequence: data.sequence,
                                plan_time: data.plan_time,
                                apply_time: data.apply_time,
                                cost_time: data.cost_time,
                                infectious: data.infectious && data.infectious.split(`,`),
                                is_fasting: data.is_fasting,
                                is_day_surgery: data.is_day_surgery,
                                is_endoscopy: data.is_endoscopy,
                                his_remark: data.his_remark,
                                remark: data.remark,
                                enum_asa: data.enum_asa,
                                enum_surgery_scale: data.enum_surgery_scale,
                                enum_surgery_type: data.enum_surgery_type,
                                dic_section_id: data.dic_section_id,
                                sectionobj: data.sectionobj,
                                inpatientobj: data.inpatientobj,
                                dic_inpatient_section_id: data.dic_inpatient_section_id,
                                dic_operating_room_id: data.dic_operating_room_id,
                                dic_operating_ward_id: data.dic_operating_ward_id,
                                enum_isolation_status: data.enum_isolation_status,
                                enum_cut_level: data.enum_cut_level,
                                age: data.visit_info.age,
                                nation: data.visit_info.nation,
                                height: data.visit_info.height,
                                weight: data.visit_info.weight,
                                bed_no: data.visit_info.bed_no,
                                visit_no: data.visit_info.visit_no,
                                outpatient_no: data.visit_info.outpatient_no,
                                visit_time: data.visit_info.visit_time,
                                visit_type: data.visit_info.enum_visit_type,
                                phone: data.visit_info.phone,
                                address: data.visit_info.address,
                                enum_visit_type: data.visit_info.enum_visit_type,
                                enum_pay_type: data.visit_info.enum_pay_type,
                                name: data.visit_info.name,
                                surgery_items: data.surgery_items, // 拟施手术 Table展现形式
                                birthday: data.visit_info.birthday,
                                card_type: data.visit_info.card_type,
                                card_no: data.visit_info.card_no,
                                insurance_no: data.visit_info.insurance_no,
                                enum_blood_type: data.visit_info.enum_blood_type,
                                enum_rh_blood_type: data.visit_info.enum_rh_blood_type,
                                enum_sex: data.visit_info.enum_sex,
                                his_id: data.visit_info.his_id,
                                plan_anaes_methods: data.plan_anaes_methods.map(d => d.value),
                                plan_diseases: data.plan_diseases,
                                plan_surgeries: data.plan_surgeries,
                                custom_status: data.custom_status,
                                plan_surgeon: data.plan_surgeon && data.plan_surgeon,
                                plan_surgeon_assistants: data.plan_surgeon_assistants && data.plan_surgeon_assistants,
                                plan_anes_doctor: data.plan_anes_doctor && data.plan_anes_doctor,
                                plan_anes_assistants: data.plan_anes_assistants && data.plan_anes_assistants,
                                plan_circuit_nurse: data.plan_circuit_nurse && data.plan_circuit_nurse,
                                plan_equipment_nurse: data.plan_equipment_nurse && data.plan_equipment_nurse,
                                is_local_anes: data.is_local_anes
                            }
                            // getone的时候把动态列字段放到obj对象里面
                            this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, obj, data)

                            resolve(obj)
                        }).catch(e => reject(e))
                    })
                },
                put: data => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        that.validateData(data)
                        if (data.isExtraBtnClick && this.$root.SurgeryScheduleShowNoAudit && this.$root.SurgeryScheduleShowNoAudit == `1`) {
                            if (data.custom_status != `已审核`) {
                                this.$message.error(`手术申请审核结果状态不是[已审核]，不能排程！`)
                                throw new Error(`EndIterative`)
                            }
                        }
                        if (data.isExtraBtnClick && !data.dic_operating_room_id) {
                            this.$message.error(`请选择手术间！`)
                            throw new Error(`EndIterative`)
                        }
                        var obj = {
                            id: data.id,
                            sequence: data.sequence,
                            plan_time: data.plan_time,
                            apply_time: data.apply_time,
                            cost_time: data.cost_time,
                            infectious: data.infectious && data.infectious.join(`,`),
                            is_fasting: data.is_fasting,
                            is_day_surgery: data.is_day_surgery,
                            is_endoscopy: data.is_endoscopy,
                            remark: data.remark,
                            custom_status: data.custom_status,
                            enum_asa: data.enum_asa || `-1`,
                            enum_surgery_scale: data.enum_surgery_scale || `-1`,
                            enum_surgery_type: data.enum_surgery_type || `-1`,
                            dic_section_id: data.sectionobj && data.sectionobj.value || `-1`,
                            dic_inpatient_section_id: data.inpatientobj && data.inpatientobj.value || `-1`,
                            dic_operating_room_id: data.dic_operating_room_id || `-1`,
                            dic_operating_ward_id: data.dic_operating_ward_id || `-1`,
                            enum_isolation_status: data.enum_isolation_status || `-1`,
                            enum_cut_level: data.enum_cut_level || `-1`,
                            visit_info: {
                                age: data.age,
                                nation: data.nation,
                                height: data.height,
                                weight: data.weight,
                                bed_no: data.bed_no,
                                visit_no: data.visit_no,
                                outpatient_no: data.outpatient_no,
                                visit_time: data.visit_time,
                                phone: data.phone,
                                address: data.address,
                                enum_visit_type: data.enum_visit_type || `-1`,
                                enum_pay_type: data.enum_pay_type || `-1`,
                                name: data.name,
                                birthday: data.birthday,
                                card_type: data.card_type,
                                card_no: data.card_no,
                                insurance_no: data.insurance_no,
                                enum_blood_type: data.enum_blood_type || `-1`,
                                enum_rh_blood_type: data.enum_rh_blood_type || `-1`,
                                enum_sex: data.enum_sex === `` ? `-1` : data.enum_sex,
                                his_id: data.his_id
                            },
                            plan_anaes_methods: data.plan_anaes_methods,
                            plan_diseases: data.plan_diseases.map(d => d.value),
                            plan_surgeries: data.plan_surgeries.map(d => d.value),
                            plan_surgeon: data.plan_surgeon && data.plan_surgeon.value,
                            plan_surgeon_assistants: data.plan_surgeon_assistants && data.plan_surgeon_assistants.map(d => d.value),
                            plan_anes_doctor: data.plan_anes_doctor && data.plan_anes_doctor.value,
                            plan_anes_assistants: data.plan_anes_assistants && data.plan_anes_assistants.map(d => d.value),
                            plan_circuit_nurse: data.plan_circuit_nurse && data.plan_circuit_nurse.map(d => d.value),
                            plan_equipment_nurse: data.plan_equipment_nurse && data.plan_equipment_nurse.map(d => d.value),
                            is_extra: data.isExtraBtnClick,
                            is_local_anes: data.is_local_anes
                        }
                        var r = _.map(data.surgery_items, d => {
                            d.plan_surgeries = d.plan_surgeries && d.plan_surgeries.value
                            return d
                        })
                        obj.surgery_items = r
                        // 修改的时候把动态列字段放到obj.extra_datas对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(this.extendColumnList, obj, data)
                        let req = this.myaxios.put(`/api/Preoperative/Apply/Put`, obj)
                        req.then(data => {
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                },
                putMany: data => {
                    let that = this
                    let reqs = data.map(d => {
                        // let info = _.filter(this.activeRoomScheduled_list, { id: d.id })[0]
                        d.scheduled_sequence = d.scheduled_sequence
                        d.plan_anes_doctor = d.plan_anes_doctor == `` || d.plan_anes_doctor < 0 ? -1 : d.plan_anes_doctor && d.plan_anes_doctor.value
                        d.plan_anes_assistants = d.plan_anes_assistants && d.plan_anes_assistants.map(a => a && a.value)
                        d.plan_circuit_nurse = d.plan_circuit_nurse && d.plan_circuit_nurse.map(a => a && a.value)
                        d.plan_equipment_nurse = d.plan_equipment_nurse && d.plan_equipment_nurse.map(a => a && a.value)
                        d.plan_anaes_methods = d.plan_anaes_methods && d.plan_anaes_methods.map(a => a && a.value)
                        return this.myaxios.put(`/api/Preoperative/Apply/UpdateSchedule`, d)
                    })
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.all(...reqs)
                        req.then(res => {
                            that.$message.success(`保存成功`)
                            resolve(res)
                        }).catch(e => {
                            reject(e)
                        })
                    })
                }
            },
            buttons: [],
            editButtons: [
                {
                    label: `确认排程`,
                    type: `default`,
                    permission: `ApplySurgery:ConfirmSchedule`
                }
            ],
            rdate: this.loadDefaultValue(),
            relation: {
                title: ``,
                visible: false,
                item: {}
            },
            o_dic_operating_ward_id: undefined,
            issetoperatingward: false,
            overrule: {
                title: `手术驳回`,
                dialogFormVisible: false,
                data: {},
                surgeryId: 0,
                columns: [
                    {
                        type: `select`,
                        prop: `reject_class`,
                        label: `驳回类别`,
                        config: {
                            allowCreate: true
                        },
                        options: this.rejectClasss
                    }, {
                        type: `select`,
                        prop: `reject_reason`,
                        label: `驳回原因`,
                        config: {
                            allowCreate: true
                        },
                        options: this.rejectReasons,
                        validate: [
                            { validator: validateLength, trigger: `blur` },
                            { required: true, message: `必填项目`, trigger: `blur` }
                        ]
                    }
                ],
                visit_info: {}
            },
            custom_status: undefined,
            inpatient_section: [],
            sysusers: [],
            columnConfig: true,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            id: undefined,
            surgery_status: [10], // 20
            dic_room_id: undefined,
            custom_status_model: null,
            timer_interval: null,
            colList: [],
            selectsurgeryType: 0,
            isAutoCalculatePlanTime: this.$root.IsAutoCalculatePlanTime,
            checkCutLevel: this.$root.CheckCutLevel || `0`,
            isCancelSurgeryApproval: this.$root.IsCancelSurgeryApproval,
            isShowDiseases: this.$root.IsShowDiseases,
            proc_GetTipItemsSchedule: this.$root.proc_GetTipItemsSchedule,
            showSwipeCard: (this.$root.carte_SwipeCard || `0`) != `0`,
            allSurgeries: [],
            isFirstAttempt: true,
            socket: null
        }
    },
    created() {
        this.loadDefaultValue()
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`ADD_Inpatient_Section_AUTH`)
        if (this.timer_interval) {
            clearInterval(this.timer_interval)
        }
    },
    mounted() {
        this.loadRejectResons()
        if (!this.timer_interval && this.getSurgeryInfoSyncTime > 0) {
            // 开启定时器，定时获取手术
            this.timer()
        }
    },
    computed: {
        ...mapGetters([
            `screenHeight`,
            `surgery/visit_type`,
            `surgery/anaesthesia_method`,
            `operation_room_auth`,
            `section_auth`,
            `inpatient_section_auth`,
            `operation_ward_auth`,
            `sys_enums`,
            `permissions`,
            `sysuser/workers_by_duty`,
            `sysuser/workers_by_dutyNew`,
            `active_ward`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        dic_operating_ward_id: {
            get: function() {
                let wardid = sessionStorage.getItem(`memory_operating_ward_id`)
                if (!this.issetoperatingward && wardid) {
                    this.o_dic_operating_ward_id = wardid
                } else if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        surgeryTypes() {
            var r = _.map(this.sys_enums && this.sys_enums.Enum_SurgeryType, d => {
                return {
                    value: d.value,
                    label: d.label
                }
            })
            return [{ value: 0, label: `全部类型` }].concat(r)
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        getSurgeryInfoSyncTime() {
            let surgeryInfoSyncTime = 0
            if (this.$root.SurgeryInfoSyncTime && this.$root.SurgeryInfoSyncTime != 0 && this.$root.SurgeryInfoSyncTime != `0`) {
                let time = parseInt(this.$root.SurgeryInfoSyncTime)
                if (time && time > 0) {
                    surgeryInfoSyncTime = time * 60000 // 5分钟，5*60000
                }
            }
            return surgeryInfoSyncTime
        },
        columnList() {
            let that = this
            let validateTime = (rule, value, callback) => {
                if (!value) {
                    return callback()
                }
                const selectedDate = new Date(value)
                const today = new Date()
                today.setHours(0, 0, 0, 0) // 重置今天的时间为00:00:00
                if (selectedDate > today) {
                    return callback(new Error(`选择的时间必须小于等于今天`))
                }
                callback()
            }

            let validatePhoneNumber = (rule, value, callback) => {
                if (!value) {
                    return callback()
                }
                const phoneReg = /^1[3-9]\d{9}$/ // 匹配中国大陆手机号
                if (!phoneReg.test(value)) {
                    return callback(new Error(`请输入有效的中国电话号码`))
                }
                callback()
            }

            let validateSocietyCard = (rule, value, callback) => {
                if (!value) {
                    return callback()
                }
                const societyCardReg = /^[0-9]{9,12}$/
                if (!societyCardReg.test(value)) {
                    return callback(new Error(`请输入正确的社保卡号`))
                }
                callback()
            }

            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息卡`,
                    width: `350`,
                    isListable: true,
                    tooltip: false
                },
                {
                    type: `string`,
                    prop: `patient_abbr`,
                    label: `患者姓名简拼`
                },
                {
                    type: `select`,
                    prop: `is_day_surgery`,
                    label: `日间手术`,
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    searchable: false,
                    sortable: false,
                    options: `enum_bool`
                },
                {
                    type: `select`,
                    prop: `enum_visit_type`,
                    label: `就诊类型`,
                    width: `80`,
                    isListable: true,
                    options: this.sys_enums.VisitType || []
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    isListable: true,
                    options: this.sys_enums.Enum_SurgeryType || [],
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `is_local_anes_val`,
                    label: `麻醉类型`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sequence`,
                    label: `申请台次`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `is_endoscopy`,
                    label: `内镜检查`,
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    searchable: false,
                    sortable: false,
                    options: `enum_bool`
                },
                {
                    type: `string`,
                    prop: `surgery_status`,
                    label: `状态`,
                    width: `80`,
                    isListable: true,
                    searchable: false,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`apply_surgery.visit_no`),
                    isListable: true,
                    searchable: false,
                    sortable: false,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    isListable: true,
                    searchable: false,
                    sortable: false,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    isListable: true,
                    searchable: true,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `60`,
                    isListable: true,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `nation`,
                    label: `民族`,
                    width: `60`,
                    isListable: true,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `remoteselect`,
                    prop: `sectionobj`,
                    label: `科室`,
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 6,
                    isListable: true,
                    searchable: true,
                    sortable: true,
                    readonly: false
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `120`,
                    isListable: true,
                    searchable: true,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `120`,
                    isListable: true,
                    searchable: false,
                    sortable: true,
                    // 自定义排序
                    sortChange: function(that, { a, b, prop, column }) {
                        let thisObj = that.$parent.$parent
                        let str1 = a[prop]
                        if (!str1) return 1
                        let str2 = b[prop]
                        if (!str2) return -1
                        let dis1Number = thisObj.DisplayOrderNumber(str1, `operating_room`)
                        let dis2Number = thisObj.DisplayOrderNumber(str2, `operating_room`)
                        return dis1Number - dis2Number
                    }
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    width: `60`,
                    isListable: true,
                    searchable: true,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    isListable: true,
                    width: `180`,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    width: `200`,
                    isListable: true,
                    searchable: true
                },
                // {
                //   type: "string",
                //   prop: "diseases",
                //   label: "计划麻醉方式",
                //   isListable: true,
                //   searchable: true,
                //   sortable: true,
                // },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划开始时间`,
                    width: `120`,
                    default: this.$moment().format(`YYYY/MM/DD 08:00:00`),
                    isListable: true,
                    searchable: true,
                    sortable: true
                },
                {
                    type: `datetime`,
                    prop: `apply_time`,
                    label: `申请时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: this.T(`apply_surgery.plan_surgeon`),
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: this.T(`apply_surgery.plan_surgeon_assistants`),
                    width: `120`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `number`,
                    prop: `scheduled_sequence`,
                    label: `台次`,
                    isListable: true,
                    sortable: true,
                    width: `100`,
                    readonly: (that, { row }) => {
                        return !this.IsSurgerySequenceEdit || row.enum_surgery_status > 20 || this.isLoadToSchedule == true || this.isLoadScheduled == true
                    }
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_circuit_nurse`,
                    label: `巡回护士`,
                    width: `140`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_anaes_methods`,
                    label: `麻醉方式`,
                    width: `140`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    options: `/api/AcisSystem/AnaesthesiaMethod/Search`
                },
                {
                    // type: `select`,
                    type: `select1`,
                    prop: `custom_status`,
                    label: `审核结果`,
                    width: `140`,
                    isListable: true,
                    colspan: 6,
                    options: (that, { row }) => {
                        let state = JSON.parse(this.$root.SurgeryApply_CustomStatus)
                        return state
                    },
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    area: [1]
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`apply_surgery.plan_equipment_nurse`),
                    width: `140`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 6,
                    config: {
                        collapseTags: true
                        // multipleLimit:2
                    }
                },
                {
                    // type: `select`,
                    type: `remoteselect`,
                    prop: `plan_anes_doctor`,
                    label: this.T(`apply_surgery.plan_anes_doctor`),
                    width: `120`,
                    isListable: true,
                    colspan: 6,
                    isShowPhoto: this.isShowWorkerPhoto,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (this.$root.UseASAeCheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    area: [1]
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_anes_assistants`,
                    label: this.T(`apply_surgery.plan_anes_assistants`),
                    width: `200`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    options: (that, { row }) => {
                        // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = _.cloneDeep(works)
                            if (this.$root.UseASAeCheck == `1`) {
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })

                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    colspan: 6,
                    area: [1],
                    config: {
                        collapseTags: true
                        // multipleLimit:2
                    }
                },
                {
                    type: `datetime`,
                    prop: `reject_date`,
                    label: `驳回时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `reject_worker_name`,
                    label: `驳回人员`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `reject_class`,
                    label: `驳回类别`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `reject_reason`,
                    label: `驳回原因`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `his_id`,
                    label: this.T(`his_id`),
                    width: `120`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    fixed: `right`,
                    label: `操作`,
                    width: that.isCancelSurgeryApproval == `1` ? `300` : `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: false,
                    sortable: false,
                    readonly: false,
                    options: function(that, { row }) {
                        if (row.enum_surgery_status !== -1 && row.enum_surgery_status !== -201) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `驳回`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `loadingOverruleView`,
                                    permission: `surgery_list:reject`
                                },
                                {
                                    class: `is-plain`,
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `LoadingUpdateViewThis`,
                                    permission: `default`
                                }
                            ]
                        } else if (row.enum_surgery_status == -201) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `审核通过`,
                                    title: `审核通过`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `cancelSurgeryApplyYes`,
                                    permission: `default`
                                },
                                {
                                    class: `is-plain`,
                                    label: `审核不通过`,
                                    title: `审核通过`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `cancelSurgeryApplyNo`,
                                    permission: `default`
                                },
                                {
                                    class: `is-plain`,
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `LoadingUpdateViewThis`,
                                    permission: `default`
                                }
                            ]
                        } else {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `LoadingUpdateViewThis`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                }
            ] // 列表列
            if (this.surgeryinfopush == `true`) {
                list.push({
                    type: `custom`,
                    prop: `push_status`,
                    label: `回传状态`,
                    width: `120`,
                    isListable: true
                })
            }
            let me = this
            // 显示新增列
            let createC = [
                {
                    type: `p`,
                    prop: `title1`,
                    isCreatable: true,
                    isEditable: true,
                    placeholder: `　患者信息`,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `p`,
                    prop: `title2`,
                    isCreatable: true,
                    isEditable: true,
                    placeholder: `　手术信息`,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `select`,
                    prop: `enum_visit_type`,
                    label: `就诊类型`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    default: 1,
                    options: this.sys_enums.VisitType || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`apply_surgery.visit_no`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_surgeries`,
                    label: `拟施手术`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: `/api/AcisSystem/Surgery/SearchIncludOpeLevel`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    change: (that, { row }) => {
                        if (_.isEmpty(row.plan_surgeries)) {
                            row.enum_surgery_scale = undefined
                        } else {
                            var max = -1
                            for (let item of row.plan_surgeries) {
                                try {
                                    if (item.description) {
                                        let level = parseInt(item.description)
                                        if (level > max) {
                                            max = level
                                        }
                                    }
                                } catch (err) {
                                    console.log(err)
                                }
                            }
                            if (max > 0) {
                                row.enum_surgery_scale = max
                            } else {
                                row.enum_surgery_scale = undefined
                            }
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `姓名`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `is_day_surgery`,
                    label: `日间手术`,
                    colspan: 6,
                    isCreatable: true,
                    isEditable: true,
                    options: `enum_bool`
                },
                {
                    type: `select`,
                    prop: `is_endoscopy`,
                    label: `内镜检查`,
                    colspan: 6,
                    isCreatable: true,
                    isEditable: true,
                    options: `enum_bool`
                },
                {
                    type: `select`,
                    prop: `enum_sex`,
                    label: `性别`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: this.sys_enums.Enum_Sex || []
                },
                {
                    type: `string`,
                    prop: `his_id`,
                    label: this.T(`his_id`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_diseases`,
                    label: `术前诊断`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: `/api/AcisSystem/Disease/Search`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `datetime`,
                    prop: `visit_time`,
                    label: `入院时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.operation_ward_auth || [],
                    colspan: 6,
                    default: this.dic_operating_ward_id,
                    validate: [{ required: true, message: `必填项目`, trigger: `change` }],
                    change: (that, { row }) => {
                        row.dic_operating_room_id = undefined
                    }
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        let r = _.filter(this[`operation_ward_auth`], { value: parseInt(row.dic_operating_ward_id) })
                        return (r && r[0] && r[0].operation_room) || []
                    },
                    change: (that, { row }) => {
                        if (this.isAutoCalculatePlanTime === `true` && !row.origion.id) {
                            if (row.dic_operating_room_id) {
                                let req = this.myaxios.get(`/api/Preoperative/Apply/GetPlanTimeByRoomId?roomId=${row.dic_operating_room_id}&planDate=${row.plan_time}`)
                                req.then(data => {
                                    this.$set(row, `plan_time`, data)
                                })
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `remoteselect`,
                    prop: `sectionobj`,
                    label: `科室`,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `remoteselect`,
                    prop: `inpatientobj`,
                    label: `病区`,
                    isCreatable: true,
                    isEditable: true,
                    // options:this["section_auth"],
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`inpatient_section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 6,
                    default: this.dic_section_surgery
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `手术时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    default: this.$moment().format(`YYYY/MM/DD 08:00:00`),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `float`,
                    prop: `cost_time`,
                    label: `预计时长`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },

                {
                    // type: this.$root.UseSurgeryScaleCheck == `1` ? `select_manyCos` : `select`,
                    type: `remoteselect`,
                    prop: `plan_surgeon`,
                    label: this.T(`apply_surgery.plan_surgeon`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (this.$root.UseSurgeryScaleCheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                let f = works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                return f
                            } else {
                                return works
                            }
                        }
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    // type: this.$root.UseSurgeryScaleCheck == `1` ? `select_manyCos_multiselect` : `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_surgeon_assistants`,
                    label: this.T(`apply_surgery.plan_surgeon_assistants`),
                    isCreatable: true,
                    isEditable: true,
                    collapseTags: false,
                    colspan: 6,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let r = {
                                workerRole: 1,
                                keyword: q && q.keyword
                            }
                            return this.myaxios.get(`/api/AcisSystem/Worker/RemoteSearch`, r).then(
                                res => {
                                    if (this.$root.UseSurgeryScaleCheck == `1`) {
                                        return res.map(d => {
                                            return {
                                                label: d.label,
                                                value: d.value,
                                                jianpin: d.jianpin,
                                                card_no: d.card_no,
                                                worker_duty: d.worker_duty,
                                                code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                            }
                                        })
                                    } else {
                                        return res.map(d => {
                                            return {
                                                label: d.label,
                                                value: d.value,
                                                jianpin: d.jianpin,
                                                card_no: d.card_no,
                                                worker_duty: d.worker_duty,
                                                code: d.code
                                            }
                                        })
                                    }
                                },
                                res => {
                                    console.log(`error`) // 调用失败
                                }
                            )
                        }
                    }
                },
                {
                    type: `date`,
                    prop: `birthday`,
                    label: `出生日期`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    validate: [{ validator: validateTime, trigger: `blur` }],
                    change: (that, { row }) => {
                        let bir = row.birthday
                        let currentDate = this.$moment()
                        let birthDate = this.$moment(bir || ``)
                        let age = this.$moment.duration(currentDate.diff(birthDate))._data
                        row.age = age.years == 0 ? (age.months == 0 ? `${age.days}天` : `${age.months}月`) : `${age.years}岁`
                    }
                },
                {
                    type: `multiselect`,
                    prop: `plan_anaes_methods`,
                    label: `麻醉方式`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return _.filter(this[`surgery/anaesthesia_method`], function(i) {
                            return i.enum_dic_type === 1 || i.enum_dic_type === 2
                        })
                    },

                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `nation`,
                    label: `民族`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgeryType || [],
                    colspan: 6,
                    default: 1
                },
                {
                    type: `select`,
                    prop: `enum_isolation_status`,
                    label: `隔离状态`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.IsolationStatus || [],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `card_type`,
                    label: `证件类型`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: this.sys_enums.Enum_CardType || []
                },
                {
                    type: `string`,
                    prop: `card_no`,
                    label: `证件号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_surgery_scale`,
                    label: `手术分级`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgeryScale || [],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_cut_level`,
                    label: `切口分类`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_CutLevel || [],
                    colspan: 6,
                    change: (that, { row }) => {
                        if (me.checkCutLevel && me.checkCutLevel == `1` && row.enum_cut_level == 1) {
                            me.$alert(`<strong>请确认是否I类手术切口</strong>`, `提示`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `address`,
                    label: `地址`,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ min: 0, max: 50, message: `长度50个字符以内`, trigger: `blur` }],
                    colspan: 12
                },
                {
                    type: `remoteselect`,
                    prop: `plan_anes_doctor`,
                    label: this.T(`apply_surgery.plan_anes_doctor`),
                    isCreatable: true,
                    isEditable: true,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 6
                },

                {
                    type: `remotemultiselect`,
                    prop: `plan_anes_assistants`,
                    label: this.T(`apply_surgery.plan_anes_assistants`),
                    isCreatable: true,
                    isEditable: true,
                    collapseTags: false,
                    options: (that, { row }) => {
                        return q => {
                            // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = _.cloneDeep(works)
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })
                            if (this.$root.UseASACheck == `1`) {
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                        // code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_asa`,
                    label: `ASA`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_ASA || [],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `phone`,
                    label: `电话`,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ validator: validatePhoneNumber, trigger: `blur` }],
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_circuit_nurse`,
                    label: this.T(`apply_surgery.plan_circuit_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    collapseTags: false,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`apply_surgery.plan_equipment_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    collapseTags: false,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_pay_type`,
                    label: `费用类别`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_PayType || [],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `insurance_no`,
                    label: `社保卡号`,
                    isCreatable: true,
                    isEditable: true,
                    validate: [
                        {
                            validator: validateSocietyCard,
                            trigger: `blur`
                        }
                    ],
                    colspan: 6
                },
                {
                    type: `multiselect`,
                    prop: `infectious`,
                    label: this.T(`apply_surgery.infectious`),
                    isCreatable: true,
                    isEditable: true,
                    // options: `enum_infectious`,
                    options: (that, { row }) => {
                        let data = this.sys_enums.Enum_Infectious || []
                        var ret = data.map(d => {
                            d.value = d.label
                            return d
                        })
                        return ret
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `is_fasting`,
                    label: `术前禁食`,
                    isCreatable: true,
                    isEditable: true,
                    options: `enum_bool`,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `height`,
                    label: `身高(cm)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `weight`,
                    label: `体重(kg)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },

                {
                    type: `string`,
                    prop: `his_remark`,
                    label: `申请备注`,
                    isCreatable: false,
                    isEditable: true,
                    readonly: true,
                    colspan: 18
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ min: 0, max: 60, message: `长度60个字符以内`, trigger: `blur` }],
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `enum_blood_type`,
                    label: `血型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_BloodType || [],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_rh_blood_type`,
                    label: `RH`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_RhBloodType || [],
                    colspan: 6
                }
            ] //  新增显示列
            list = list.concat(createC)
            // 显示动态扩展列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)
            var colListthis = _.cloneDeep(list)
            colListthis = this.$surgeryInfoExtraParamUtil.SetOtherSettingColumn(colListthis, this.otherSettingColumn)
            this.colList = colListthis
            return list
        },
        editColumnList() {
            return this.colList
        },
        operationRoom() {
            return (
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            )
        },
        customStatus() {
            let cusStaArry = (this.$root.SurgeryApply_CustomStatus && JSON.parse(this.$root.SurgeryApply_CustomStatus)) || []
            return cusStaArry || []
        },
        // 判断是否有编辑台次权限
        IsSurgerySequenceEdit() {
            return _.find(this.permissions, { no: `apply_surgery_SequenceEdit` }) != undefined
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        },
        titleLabel() {
            return function(row) {
                let title = `患者:${row.patient_name} 性别:${row.sex || `--`} 年龄:${row.age || `--`} 
                病例号:${row.visit_no || `--`} 
                术前诊断:${row.diseases || `--`}
                拟施手术:${row.surgeries || `--`}
                ${this.T(`Schedule.plan_surgeon`)}:${row.surgeon || `--`}
                手术科室:${row.dic_section || `--`}
                ${this.T(`Schedule.plan_anes_doctor`)}:${row.plan_anes_doctor == null ? `` : row.plan_anes_doctor.label}
                申请台次:${row.sequence || ``}
                申请时间:${this.$moment(row.apply_time).format(`YYYY-MM-DD HH:mm:ss`)}
                备注:${row.his_remark || ``}
                传染病:${row.infectious || ``}
                麻醉类型:${row.is_local_anes_val || ``}
                `
                return title
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        // this.destroyed()
        next()
    },
    destroyed() {
        clearInterval(this.timer_interval)
    },
    beforeDestroy() {
        // 离开页面暂存页面已设置内容，方便下次进入 记忆功能
        sessionStorage.setItem(`memory_operating_ward_id`, this.dic_operating_ward_id)
    },
    methods: {
        btnprintCard() {
            let printlist = this.checkedRows
            if (printlist && printlist.length > 0) {
                let codes = printlist.map(d => d.visit_no).toString()
                let ids = printlist.map(d => d.id).toString()
                // 调用生成条形码图片
                let req = this.myaxios.get(`/api/AcisSystem/SystemServer/CreateBarcodesImg?codes=${codes}&category=患者`)
                console.log(this.$root.DOCUMENT[`SSSQ002`])
                req.then(data => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: this.$root.DOCUMENT.SSSQ002,
                                id1: ids,
                                objId: codes
                            },
                            { isShowSendPrintMessage: this.$root.isShowSendPrintMessage }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            } else {
                this.$message.warning(`未选择打印患者`)
            }
        },
        ReadCard() {
            let that = this
            if (that.socket && that.socket.readyState === WebSocket.OPEN) {
                console.log(`Connection already exists 连接已存在`)
                return
            }
            that.connectAndSend()
        },
        connectAndSend() {
            let that = this
            let wsImpl = window.WebSocket || window.MozWebSocket
            let newSocket = new wsImpl(`ws://127.0.0.1:5001?Token=Meehealth`)
            newSocket.onopen = function() {
                console.log(`WebSocket 连接已建立`)
                // 第一次发送消息
                that.sendMessage(newSocket, `1`)
            }
            newSocket.onmessage = function(event) {
                console.log(`=====收到消息=====`, event.data)
                let patientInfo = JSON.parse(event.data)
                let patient = JSON.parse(patientInfo.patient)
                console.log(`收到消息:patient`, patient)
                if (that.isFirstAttempt) {
                    // 第一次尝试
                    if (!patient) {
                        // 无数据，发送第二次尝试
                        console.log(`无数据`)
                        that.sendMessage(newSocket, `0`)
                    } else {
                        // 有数据，关闭连接
                        that.isFirstAttempt = false
                        console.log(`有数据 处理数据`, patient, `>>>>>>`)
                        that.swipeCardScanCode(patient)
                        newSocket.close()
                    }
                } else {
                    that.$message.warning(`请刷身份证或医保卡`)
                    newSocket.close()
                }
            }
            newSocket.onerror = (error) => {
                console.error(`WebSocket error:`, error)
            }
            newSocket.onclose = () => {
                console.log(`WebSocket disconnected`)
                that.socket = null
                that.isFirstAttempt = true
            }
            that.socket = newSocket
        },
        sendMessage(ws, param) {
            if (ws.readyState === WebSocket.OPEN) {
                let message = JSON.stringify({
                    action: `ReadCard`,
                    param: param
                })
                ws.send(message)
                console.log(`Sent:`, message)
            }
        },
        swipeCardScanCode(patient) {
            return new Promise((resolve, reject) => {
                let that = this
                let str = JSON.stringify(patient)
                // console.log(`SwipeCardScanCode`, str)
                // const data = {
                //     id: 995,
                //     visit_no: `6666`,
                //     name: `测试测试`,
                //     age: `88sui`
                // }
                // if (data.id > 0) {
                //     // 修改
                //     that.LoadingUpdateViewThis({ row: data })
                // } else {
                //     // 新增
                //     this.$refs[`surgery-list`].LoadingAddView(data)
                // }
                let req = this.myaxios.get(`/api/Preoperative/Apply/SwipeCardScanCode?patientstr=${str}`)
                req.then(data => {
                    console.log(`SwipeCardScanCode`, data)
                    if (data) {
                        if (data === `error`) {
                            this.$message.error(`调用kettle获取患者信息失败！详情查阅日志！`)
                        } else {
                            if (data) {
                                if (data.id > 0) {
                                    // 修改
                                    that.LoadingUpdateViewThis({ row: data })
                                } else {
                                    // 新增
                                    this.$refs[`surgery-list`].LoadingAddView(data)
                                }
                            } else {
                                this.$message.error(`调用kettle获取患者信息异常！详情查阅日志！`)
                            }
                        }
                    } else {
                        this.$message.error(`未获取到返回值，请检查读卡配置！`)
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        validateData(data) {
            let societyCardReg = ``
            if (data.card_no && data.card_no !== `-2147483648`) {
                if (!data.card_type) {
                    this.$message.error(`请选择证件类型`)
                    throw new Error(`EndIterative`)
                }
                switch (parseInt(data.card_type)) {
                case 1:
                    societyCardReg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/ // 身份证
                    break
                case 2:
                    societyCardReg = /^[A-Za-z0-9]{5,20}$/ // 护照
                    break
                }
                if (!societyCardReg.test(data.card_no)) {
                    this.$message.error(`证件号格式错误`)
                    throw new Error(`EndIterative`)
                }
            }
        },
        checkedRow({ row }) {
            this.checkedRows = row
        },
        btnprint() {
            let docId = this.$root.DOCUMENT[`SSSQ001`]
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                // 批量打印手术通知单
                let printlist = this.checkedRows
                if (printlist.length) {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: docId,
                                id1: `99999`,
                                objId: printlist.map(d => d.id).toString()
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                } else {
                    this.$message.warning(`请选择需要打印的手术申请`)
                }
            }).catch(e => {
                console.log(e)
            })
        },
        timer() {
            let that = this
            that.timer_interval = setInterval(() => {
                that.ReloadListData()
                that.loadNewSurgeryList()
            }, this.getSurgeryInfoSyncTime)
        },
        changed(changed) {
            this.selectsurgeryType = changed
            this.ReloadListData()
        },
        ReloadListData() {
            console.log(`定时调surgery-list ReloadListData方法`)
            console.log(this)
            console.log(this.$refs[`surgery-list`])
            if (this.$refs[`surgery-list`]) {
                this.$refs[`surgery-list`].ReloadListData()
            }
        },
        loadDefaultValue() {
            let ApplySurgeryDateDiff = this.$root.ApplySurgeryDateDiff
            if (ApplySurgeryDateDiff) {
                let rule = ApplySurgeryDateDiff.split(`,`)

                return [
                    this.$moment()
                        .add(rule[0], `days`)
                        .format(`YYYY/MM/DD HH:mm:ss`),
                    this.$moment()
                        .add(rule[1], `days`)
                        .format(`YYYY/MM/DD HH:mm:ss`)
                ]
            } else {
                return [
                    this.$moment()
                        .add(0, `days`)
                        .format(`YYYY/MM/DD HH:mm:ss`),
                    this.$moment()
                        .add(0, `days`)
                        .format(`YYYY/MM/DD HH:mm:ss`)
                ]
            }
        },
        loadDocList(operatingWardId, q) {
            let r = {
                operatingWardId: operatingWardId || (this.active_ward && this.active_ward.value.split(`_`)[1]),
                workerRole: 1,
                keyword: q && q.keyword
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/Search`, r)
                req.then(data => {
                    resolve(data)
                })
            })
        },
        loadNurseList(operatingWardId, q) {
            let r = {
                operatingWardId: operatingWardId || (this.active_ward && this.active_ward.value.split(`_`)[1]),
                workerRole: 2,
                keyword: q && q.keyword
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/Search`, r)
                req.then(data => {
                    resolve(data)
                })
            })
        },
        loadingOverruleView({ index, row }) {
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `此操作将驳回“${row.patient_name}”“${row.visit_no}”的手术申请`), this.$createElement(`p`, `是否继续?`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.loadDocList()
                    this.loadNurseList()
                    var col = _.find(this.overrule.columns, c => c.prop == `reject_reason`)
                    if (col) {
                        if (this.rejectReasons && this.rejectReasons.length > 0) {
                            col.options = this.rejectReasons
                            col.type = `select`
                        } else {
                            col.options = []
                            col.type = `string`
                        }
                    }
                    var col2 = _.find(this.overrule.columns, c => c.prop == `reject_class`)
                    if (col2) {
                        if (this.rejectClasss && this.rejectClasss.length > 0) {
                            col2.options = this.rejectClasss
                            col2.type = `select`
                        } else {
                            col2.options = []
                            col2.type = `string`
                        }
                    }
                    this.overrule.dialogFormVisible = true
                    this.overrule.surgeryId = row.id
                    this.overrule.visit_info = {
                        id: row.visit_id,
                        visit_no: row.visit_no,
                        enum_visit_type: row.visit_type,
                        his_id: row.his_id,
                        name: row.patient_name
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        LoadingUpdateViewThis({ row, index }) {
            this.$refs[`surgery-list`].LoadingUpdateView({ row: row, index: index }).then(data => {
                let showsavebtn = true
                // 手术麻醉单归档后不能在保存
                let caneditarchived = this.IsHavePermission(`dic_surgery_caneditarchived`)
                if (caneditarchived) {
                    showsavebtn = true
                } else {
                    showsavebtn = !data.is_archived
                }
                this.$refs[`surgery-list`].$children[3].btnVisible = showsavebtn
            })
        },
        cancelSurgeryApplyYes({ row, index }) {
            // 取消手术审核通过
            let that = this
            let req = this.myaxios.put(`/api/Preoperative/Schedule/CancelSurgeryApply?surgeryId=${row.id}&&type=1`)
            req.then(data => {
                that.$refs[`surgery-list`].ReloadListData()
            }).catch(e => {})
        },
        // 取消手术审核不通过
        cancelSurgeryApplyNo({ row, index }) {
            let that = this
            let req = this.myaxios.put(`/api/Preoperative/Schedule/CancelSurgeryApply?surgeryId=${row.id}&&type=-1`)
            req.then(data => {
                that.$refs[`surgery-list`].ReloadListData()
            }).catch(e => {})
        },
        saveOverrule(row) {
            let that = this
            let requestData = {
                id: this.overrule.surgeryId,
                visit_info: this.overrule.visit_info,
                reject_reason: row.reject_reason,
                reject_class: row.reject_class
            }

            let req = this.myaxios.put(`/api/Preoperative/Apply/Reject`, requestData)
            req.then(data => {
                // 调用手术回写
                let pushModel = {
                    surgeryId: this.overrule.surgeryId,
                    surgeryInfoSendType: 1
                }
                var reps = this.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, pushModel)
                reps.then(data => {
                    that.overrule.dialogFormVisible = false
                    that.$refs[`surgery-list`].ReloadListData()
                })
            }).catch(e => {})
        },
        ReloadData() {
            // added by xiaorui ACIS-22650,更改日期触发更新列表
            let that = this
            return new Promise((resolve, reject) => {
                let req = that.myaxios.post(`/api/Preoperative/Apply/GetSurgeryWithStatus?begin=${this.rdate[0]}&end=${this.rdate[1]}`, that.surgery_status)
                req.then(data => {
                    let r = data
                    if (that.dic_operating_ward_id) {
                        r = _.filter(data, d => {
                            let result = true
                            if (that.dic_operating_ward_id) {
                                result = d.dic_operating_ward_id == that.dic_operating_ward_id
                            }

                            if (result && that.dic_room_id) {
                                result = d.dic_operating_room_id == that.dic_room_id
                            }
                            return result
                        })
                    }
                    r = _.map(r, d => {
                        d.class_name = `surgery_status_${d.enum_surgery_status} surgery_type_${d.enum_surgery_type}`
                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                        return d
                    })

                    // 根据选择的手术类型做过滤，择期，急诊，日间
                    if (r.length > 0 && that.selectsurgeryType > 0) {
                        if (that.selectsurgeryType == 1 || that.selectsurgeryType == 2) {
                            r = _.filter(r, function(i) {
                                return i.enum_surgery_type == that.selectsurgeryType
                            })
                        }

                        if (that.selectsurgeryType == 3) {
                            r = _.filter(r, function(i) {
                                return i.is_day_surgery == true
                            })
                        }
                    }
                    // 根据选择的状态做过滤
                    if (r.length > 0 && that.custom_status_model) {
                        r = _.filter(r, function(i) {
                            return i.custom_status == that.custom_status_model
                        })
                    }
                    if (that.proc_GetTipItemsSchedule) {
                        that.getSurgeryTipItems(r)
                    }
                    that.allSurgeries = r
                    resolve(r)
                }).catch(e => {
                    reject([])
                })
            })
            // that.$refs["surgery-list"].ReloadListData()  /api/AcisSystem/InpatientSection/Post
        },
        loadRejectResons() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ApplyRejectResons`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        let r = data.value.trim().split(`|`)
                        this.rejectReasons = r[0]
                            .trim()
                            .split(`,`)
                            .map(x => {
                                return {
                                    label: x,
                                    value: x
                                }
                            })
                        if (r.length > 1) {
                            this.rejectClasss = r[1]
                                .trim()
                                .split(`,`)
                                .map(x => {
                                    return {
                                        label: x,
                                        value: x
                                    }
                                })
                        }
                    } else {
                        this.rejectReasons = []
                        this.rejectClasss = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        // 新手术申请通知
        loadNewSurgeryList() {
            if (this.$root.IsShowNewSurgeryAlert && this.$root.IsShowNewSurgeryAlert == `1` && this.dic_operating_ward_id) {
                this.myaxios.get(`/api/Preoperative/Apply/GetNewApplySurgerys`, { wardId: this.dic_operating_ward_id, syncMinutes: this.$root.SurgeryInfoSyncTime }).then(data => {
                    if (data && data.length > 0) {
                        // added by 是否显示新手术通知提示
                        let alertmsg2 = ``
                        _.filter(data, i => i.surgery_status == `新申请`).map(d => {
                            alertmsg2 += `<strong>${d.patient_name}是新手术申请</strong><br/>`
                        })
                        if (alertmsg2) {
                            this.$notify.info({
                                title: `提醒`,
                                dangerouslyUseHTMLString: true,
                                message: alertmsg2,
                                position: `bottom-right`,
                                duration: 15000,
                                offset: 100
                            })
                            return true
                        }
                    }
                })
            }
        },
        getSurgeryTipItems(r) {
            let that = this
            let req = this.myaxios.post(
                `api/Intraoperative/Anaesthesia/GetSurgeryTipItems`,
                {
                    begin: that.$moment(this.rdate[0]).format(`YYYY/MM/DD 00:00:00`),
                    end: that.$moment(this.rdate[1]).format(`YYYY/MM/DD 23:59:59`),
                    surgery_status: that.surgery_status,
                    proc_key: that.proc_GetTipItemsSchedule
                },
                null,
                false
            )
            req.then(data => {
                if (r && data && data.length) {
                    _.forEach(r, d => {
                        let surgeryTip = data.filter(i => i.biz_surgeryinfo_id == d.id) || []
                        that.$set(d, `patientInfoTipItemsList`, surgeryTip)
                    })
                    this.$refs[`surgery-list`].AppendListData(r)
                }
            }).catch(e => {
                console.log(e)
            })
        },
        DisplayOrderNumber(str, type) {
            let that = this
            let r = _.find(type == `section` ? that.section_auth : that.operation_room_auth, { label: str })
            return (r && r.display_order) || 10000
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`surgery-list`].ReloadListData()
        },
        dic_operating_ward_id: function(newVlaue, oldValue) {
            this.$refs[`surgery-list`].ReloadListData()
            this.loadDocList()
            this.loadNurseList()
        },
        surgery_status: function() {
            this.$refs[`surgery-list`].ReloadListData()
        },
        dic_room_id: function() {
            this.$refs[`surgery-list`].ReloadListData()
        },
        custom_status_model: function() {
            this.$refs[`surgery-list`].ReloadListData()
        }
    }
}
</script>
<style lang="less">
.plan_diseases{
    .el-select__tags-text{
        white-space:normal;
    }
    .el-tag--mini{
        height: unset !important;
    }
}
.plan_surgeries{
    .el-select__tags-text{
        white-space:normal;
    }
    .el-tag--mini{
        height: unset !important;
    }
}
.title1 p {
    background: lightgray;
    font-size: 20px;
}
.title2 p {
    background: lightgray;
    font-size: 20px;
}
.surgery_status_20 td {
    color: var(--primary-color, #009688);
}
.surgery_type_1 td {
    color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/ApplySurgery.vue